import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 12h-13","key":"svg-0"}],["path",{"d":"M6 9l-3 3l3 3","key":"svg-1"}],["path",{"d":"M18.5 9.5l2.5 2.5l-2.5 2.5l-2.5 -2.5l2.5 -2.5","key":"svg-2"}]]

const IconArrowLeftRhombus = createReactComponent('outline', 'arrow-left-rhombus', 'ArrowLeftRhombus', __iconNode);

export default IconArrowLeftRhombus;